import React, { useContext, useEffect, useMemo, useState } from 'react'
import { Button, Card, Dialog, Notification, Progress, Radio, Select, toast } from 'components/ui';
import InputModern from 'components/ui/Input/InputModern';
import { CompanyContext } from 'contexts/CompanyContext';
import { HiCheckCircle, HiMinus, HiOutlineCreditCard, HiOutlineLogout, HiOutlineMinus, HiPlus } from 'react-icons/hi';
import { HiCalendar, HiChevronRight, HiOutlineCheck, HiOutlineCheckCircle, HiOutlinePlus, HiRocketLaunch, HiSparkles, HiUserCircle } from 'react-icons/hi2';
import { api as Api, API_HOST } from 'api/http';
import { formatNumber } from 'utils/formatNumber';
import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js'
import { SessionContext } from 'contexts/SessionContext';
import { useSelector } from 'react-redux';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import ProductPlan from './ProductPlan';
import MySubscription from './MySubscription';
import CardDialog from './CardDialog';
import { Loading } from 'components/shared';
import { Trans } from 'react-i18next';
import { PriorityModalContext } from 'contexts/PriorityModalContext';
import { FREE_TRIAL_DAYS, HAS_PAID_TRIAL, HAS_FREE_TRIAL, TRIAL_PRICE_DISPLAY, HIDDEN_PLANS_WHEN_NO_SUBSCRIPTION, PUBLIC_URL, SIZES } from 'components/ui/utils/constant';
import { objectToQueryParams } from 'utils/objectToQueryParams';
import { TbCaretDown, TbChevronDown, TbLogout, TbLogout2, TbPower } from 'react-icons/tb';
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { motion, AnimatePresence } from 'framer-motion';
import useDarkMode from 'utils/hooks/useDarkMode';
import { RiTwitterXFill } from 'react-icons/ri';
import { getDefaultPlanTypeCookie } from 'utils/cookies';

export const AI_STUDIO_PLANS = [
    "starter", "scale", "hardcore"
];

export const SOCIAL_PLANS = [
    "pro", "team", "agency", "enterprise"
];

const Subscription = ({ isModal = false, defaultTab = "" }) => {
    
    const hashUserId = (userId) => {
        let hash = 0;
        for (let i = 0; i < userId?.toString().length; i++) {
            hash = ((hash << 5) - hash) + userId.toString().charCodeAt(i);
            hash = hash & hash;
        }
        return Math.abs(hash);
    }

    const getInitialValues = () => {
        return { plan: 1, frequency: 'year' };
        // if (!user?.id) return { plan: 1, frequency: 'year' };
        
        // const hash = hashUserId(user.id);
        // return {
        //     plan: (hash % 2) + 1, // Returns 1, 2
        //     frequency: hash % 2 === 0 ? 'year' : 'year'
        // };
    }

    const navigate = useNavigate();
    const { roles } = useContext(CompanyContext);
    const { closeModalPriority } = useContext(PriorityModalContext);
    const { user, actions, updateUserData, planType } = useContext(SessionContext);
    const [ searchParams ] = useSearchParams();
    const [ products, setProducts ] = useState([]);
    const [ isLoading, setIsLoading ] = useState(false);
    const [ billingFrequency, setBillingFrequency ] = useState(getInitialValues().frequency);
    const [ additionalUsers, setAdditionalUsers ] = useState(0);
    const [ additionalCompanies, setAdditionalCompanies ] = useState(0);
    const [ selectedPlan, setSelectedPlan ] = useState(getInitialValues().plan);
    const [ selectedAdditionalWords, setSelectedAdditionalWords ] = useState(0);
    const [ selectedAdditionalImages, setSelectedAdditionalImages ] = useState(0);
    const [ subscriptionCreated, setSubscriptionCreated] = useState(false);
    const [ total, setTotal ] = useState(0);
    const [ cardDialogOpened, setCardDialogOpened ] = useState(false);
    const [ isSubmittingCard, setIsSubmittingCard ] = useState(false);
    const [ isSubmittingChangePlan, setIsSubmittingChangePlan ] = useState(false);
    const [ isCustomizePlanOpened, setIsCustomizePlanOpened ] = useState(false);
    const [ selectedTab, setSelectedTab ] = useState("social");
    const [isDarkMode] = useDarkMode();
    
    const stripe = useStripe();
    const elements = useElements();

    // Tab configuration
    const tabConfig = [
        {
            value: 'social',
            icon: <HiCalendar className="text-lg" />,
            label: 'Social Media',
            gradient: 'from-blue-500 via-cyan-500 to-purple-500'
        },
        {
            value: 'ai_studio',
            icon: <HiSparkles className="text-lg" />,
            label: 'AI Studio',
            gradient: 'from-purple-500 via-pink-500 to-orange-500',
            attention: true,
        }
    ];

    const freeTrialdEndsAt = new Date().getTime() + 1000 * 3600 * 24 * FREE_TRIAL_DAYS;

    const discountText = process.env.REACT_APP_DEFAULT_DISCOUNT;
    const discountFactor = parseFloat(discountText) ? 1 - parseFloat(discountText) / 100 : 1;

    // A product can have no active price for a given frequency (old prices soft-deleted
    // before the new ones exist), so never index the filtered prices array directly.
    const getPrice = (item, frequency = billingFrequency) => item?.prices?.find(price => price.recurring == frequency);

    const plans = useMemo(() => {
        return products
            ?.filter(item => item.type == "plan")
            ?.sort((a, b) => (a?.prices?.[0]?.amount ?? 0) - (b?.prices?.[0]?.amount ?? 0))
    }, [products]);

    const handleSubmitStripe = async (event, stripeCheckout = false) => {

        event && event?.preventDefault();
        // if (elements == null) {
        //     return;
        // }
        
        setIsSubmittingCard(true);
        setIsSubmittingChangePlan(true);

        const planObj = (products.filter(item => item.id == selectedPlan))[0];
        const planPriceObj = (planObj.prices.filter(price => price.recurring == billingFrequency))[0];

        const addUserObj = (products.filter(item => item.name == 'add-user'))[0];
        const userPriceObj = (addUserObj.prices.filter(price => price.recurring == billingFrequency))[0];

        const addCompanyObj = (products.filter(item => item.name == 'add-company'))[0];
        const companyPriceObj = (addCompanyObj.prices.filter(price => price.recurring == billingFrequency))[0];
        
        let wordsPriceObj;
        if (selectedAdditionalWords > 0) {
            const wordsObj = (products.filter(item => item.id == selectedAdditionalWords))[0];
            wordsPriceObj = (wordsObj.prices.filter(price => price.recurring == billingFrequency))[0];
        }
        
        let imagesPriceObj;
        if (selectedAdditionalImages > 0) {
            const imagesObj = (products.filter(item => item.id == selectedAdditionalImages))[0];
            imagesPriceObj = (imagesObj.prices.filter(price => price.recurring == billingFrequency))[0];
        }
        
        let _paymentMethod;
        if (!stripeCheckout) {
            if (!user?.pm_last_four || !user?.subscription?.id) {
                const {error, paymentMethod} = await stripe.createPaymentMethod({
                    type: 'card',
                    card: elements.getElement(CardElement),
                });
                if (error) {
                    setIsSubmittingCard(false);
                    setIsSubmittingChangePlan(false);
                    toast.push(<Notification title={error.message} type="warning" />, { placement: 'top-center' });
                    return;
                }
                _paymentMethod = paymentMethod;
            }
        }

        let data = {
            resume: 1,
            payment_method_id: _paymentMethod?.id || undefined,
            prices: [{ "id": planPriceObj.id }],
            referral: window?.affiliateId ? window?.affiliateId : undefined,
            // promotional_code: process.env?.REACT_APP_DEFAULT_COUPON_CODE ? process.env?.REACT_APP_DEFAULT_COUPON_CODE : undefined,
            checkout: stripeCheckout ? 1 : 0,
            success_url: `${PUBLIC_URL}/subscription?success=1`,
            cancel_url: `${PUBLIC_URL}/subscription?success=0`,
        };
        
        additionalUsers ? data.prices.push({ "id": userPriceObj.id, "quantity": additionalUsers }) : void 0;
        additionalCompanies ? data.prices.push({ "id": companyPriceObj.id, "quantity": additionalCompanies }) : void 0;
        selectedAdditionalWords && wordsPriceObj ? data.prices.push({ "id": wordsPriceObj.id }) : void 0;
        selectedAdditionalImages && imagesPriceObj ? data.prices.push({ "id": imagesPriceObj.id }) : void 0;

        if (stripeCheckout) {
            window.location.href = `${API_HOST}/api/subscriptions/checkout?token=${localStorage.getItem(`token`)}&${objectToQueryParams(data)}`;
            return;
        }
        
        if (!user?.subscription?.id) {
            Api.post(`/subscriptions`, {}, data).then(async (response) => {
                try {
                    if (window?.fbq) {
                        window?.fbq('track', 'StartTrial', {
                            'value': user?.id,
                            'curreny': 'USD',
                            'subscription_id': user?.id
                        });
                        window?.fbq('track', 'Purchase', {
                            'value': user?.id,
                            'curreny': 'USD',
                            'content_ids': [`${user?.id}`],
                            'content_type': 'product'
                        });
                    }
                    if (window?.gtag) {
                        window?.gtag('event', 'conversion', {
                            'send_to': 'AW-11483401020/KReUCK_n-YwZELyW2-Mq',
                            'value': total,
                            'currency': 'USD',
                            'id': user?.id
                        });
                        window.gtag('event', 'purchase', {
                            'transaction_id': user?.id,
                            'value': total,
                            'currency': 'USD',
                            'items': [{
                              'id': selectedPlan,
                              'name': selectedPlan,
                              'quantity': 1,
                              'price': total
                            }]
                        });
                    }
                } catch (err) {}
                await updateUserData();
                setSubscriptionCreated(true);
            }).catch((err) => {
                toast.push(<Notification title={err?.message || 'An error ocurred. Please, try again later'} type="danger" />, { placement: 'top-center' });
            }).finally(() => {
                setIsSubmittingCard(false);
                setIsSubmittingChangePlan(false);
            });
        } else {
            Api.put(`/subscriptions`, {}, data).then((response) => {
                updateUserData();
                toast.push(<Notification title="Your subscription has been successfully modified." type="success" />, { placement: 'top-center' });
                closeModalPriority();
            }).catch((err) => {
                toast.push(<Notification title={err.message} type="danger" />, { placement: 'top-center' });
            }).finally(() => {
                setIsSubmittingChangePlan(false);
                setIsSubmittingCard(false);
            });
        }
    }

    const addCompanies = () => {
        setAdditionalCompanies(additionalCompanies + 1);
    }
    
    const addUsers = () => {
        setAdditionalUsers(additionalUsers + 1);
    }

    const removeCompanies = () => {
        if (additionalCompanies == 0) return;
        setAdditionalCompanies(additionalCompanies - 1);
    }
    
    const removeUsers = () => {
        if (additionalUsers == 0) return;
        setAdditionalUsers(additionalUsers - 1);
    }

    const handleOnNext = () => {
        if (!user?.pm_last_four || !user?.subscription?.id) {
            setCardDialogOpened(true)
        } else {
            handleSubmitStripe();
        }
    }

    useEffect(() => {
        let isMounted = true;
        setIsLoading(true);

        const fetchAllProducts = async () => {
            try {
                let allProducts = [];
                // Fetch first page to get total count
                const initialResponse = await Api.get(`/products?include=prices&page[size]=30`);
                allProducts = [...initialResponse.data];
                const meta = initialResponse.meta;
                const totalPages = meta && meta.total && meta.per_page ? Math.ceil(meta.total / meta.per_page) : 1;

                // Fetch remaining pages, if any
                if (totalPages > 1) {
                    const fetches = [];
                    for (let page = 2; page <= totalPages; page++) {
                        fetches.push(
                            Api.get(`/products?include=prices&page[number]=${page}&page[size]=30`)
                        );
                    }
                    const responses = await Promise.all(fetches);
                    responses.forEach(resp => {
                        allProducts = [...allProducts, ...resp.data];
                    });
                }

                // Drop soft-deleted (replaced) prices, then order by ID descending
                allProducts.forEach(product => {
                    if (Array.isArray(product.prices)) {
                        product.prices = product.prices.filter(price => !price.deleted_at);
                        product.prices.sort((a, b) => {
                            if (a.id < b.id) return 1;
                            if (a.id > b.id) return -1;
                            return 0;
                        });
                    }
                });

                if (isMounted) setProducts(allProducts);
            } catch (err) {
                // Optionally handle error
            } finally {
                if (isMounted) setIsLoading(false);
            }
        };

        fetchAllProducts();

        return () => { isMounted = false; }

    }, []);

    useEffect(() => {
        if (!selectedPlan || products?.length == 0) {
            setTotal(0);
            return;
        }

        const planObj = (products.filter(item => item.id == selectedPlan))[0];
        const planPriceObj = (planObj.prices.filter(price => price.recurring == billingFrequency))[0];
        const planPrice = Math.floor(planPriceObj?.amount / 100);

        const addUserObj = (products.filter(item => item.name == 'add-user'))[0];
        const userPriceObj = (addUserObj.prices.filter(price => price.recurring == billingFrequency))[0];
        const userPrice = Math.floor(userPriceObj?.amount * additionalUsers / 100);

        const addCompanyObj = (products.filter(item => item.name == 'add-company'))[0];
        const companyPriceObj = (addCompanyObj.prices.filter(price => price.recurring == billingFrequency))[0];
        const companyPrice = Math.floor(companyPriceObj?.amount * additionalCompanies / 100);
        
        let wordsPrice = 0;
        if (selectedAdditionalWords > 0) {
            const wordsObj = (products.filter(item => item.id == selectedAdditionalWords))[0];
            const wordsPriceObj = (wordsObj.prices.filter(price => price.recurring == billingFrequency))[0];
            wordsPrice = Math.floor(wordsPriceObj?.amount / 100);
        }
        
        let imagesPrice = 0;
        if (selectedAdditionalImages > 0) {
            const imagesObj = (products.filter(item => item.id == selectedAdditionalImages))[0];
            const imagesPriceObj = (imagesObj.prices.filter(price => price.recurring == billingFrequency))[0];
            imagesPrice = Math.floor(imagesPriceObj?.amount / 100);
        }

        setTotal(planPrice * discountFactor + userPrice + companyPrice + wordsPrice + imagesPrice);

    }, [products, selectedPlan, billingFrequency, additionalUsers, additionalCompanies, selectedAdditionalWords, selectedAdditionalImages])

    useEffect(() => {
        if (!!user?.subscription) {
            const actualAddOns = user?.subscription?.items?.filter(item => item.product.type == "add-on");
            const companies = actualAddOns?.filter(item => item.product.name == "add-company")?.[0]?.quantity;
            const users = actualAddOns?.filter(item => item.product.name == "add-user")?.[0]?.quantity;
            setBillingFrequency(user?.subscription?.items?.[0]?.price?.recurring);
            setAdditionalUsers(users || 0);
            setAdditionalCompanies(companies || 0);
            setSelectedPlan(user?.subscription?.items?.filter(item => item.product.type == "plan")?.[0]?.product?.id || 1)
        }
    }, []);
    
    useEffect(() => {
        const handleResize = () => {
            const isDesktop = window.innerWidth >= 1024; // lg breakpoint is 1024px
            setIsCustomizePlanOpened(false); // isDesktop
        };

        // Set initial state
        handleResize();

        // Add event listener for window resize
        window.addEventListener('resize', handleResize);

        // Cleanup
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const userAuthority = roles?.map(e => e?.name);
        if (!userAuthority.includes('owner')) {
            navigate('/');
        }
    }, [roles]);

    // Auto-select first plan when switching tabs
    useEffect(() => {
        if (plans && plans.length > 0) {
            const filteredPlans = plans
                .filter(e => !(HIDDEN_PLANS_WHEN_NO_SUBSCRIPTION)?.toLowerCase()?.includes(e?.name?.toLowerCase()))
                .filter(e => selectedTab === "social" ? SOCIAL_PLANS.includes(e?.name) : AI_STUDIO_PLANS.includes(e?.name));
            
            // Check if current selected plan is in the filtered plans
            const currentPlanInTab = filteredPlans.find(plan => plan.id === selectedPlan);
            
            // If not, select the first plan in the tab
            if (!currentPlanInTab && filteredPlans.length > 0) {
                setSelectedPlan(filteredPlans[0].id);
            }
        }
    }, [selectedTab, plans]);

    // Calculate the default tab based on the actual user subscription, defaultTab param and cookie param
    useEffect(() => {
        if (defaultTab) { 
            setSelectedTab(defaultTab);
            return;
        }

        if (planType) {
            setSelectedTab(planType);
            return;
        }

        const cookiePlanType = getDefaultPlanTypeCookie();
        if (cookiePlanType) {
            setSelectedTab(cookiePlanType);
            return;
        }

        setSelectedTab('social');
    }, [defaultTab, planType]);

    if (isLoading) {
        return (
            <div className='w-full min-w-[250px] h-full min-h-[400px] flex items-center justify-center'>
                <Loading type={`element`} />
            </div>
        )
    }

    if (!!user?.subscription?.id && !isModal) {
        return <MySubscription />
    }

    return (
        <div className={`flex flex-col h-full max-h-full overflow-hidden relative ${isModal && 'max-h-[88vh] lg:max-h-[94vh]'}`}>
            {/* Fixed Tabs Navigation */}
            <motion.div
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                className="w-full top-0 z-20 bg-secondary-600 dark:bg-gray-900 px-4 lg:px-6 pt-6 pb-2 shrink-0 min-w-[390px]"
            >
                <div className="!pt-2 !pb-2 gap-2 bg-gray-100/80 dark:bg-gray-800/50 rounded-2xl backdrop-blur-xl flex flex-col sm:flex-row flex-wrap items-center !pb-0 !border-0 !px-0 !overflow-visible">
                
                    {/* Header Section */}
                    <motion.div
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.2, duration: 0.5 }}
                        className="w-full sm:w-auto sm:flex-none sm:mr-4 lg:mr-20 ml-4 mb-2 sm:mb-0"
                    >
                        <div className="flex items-center gap-3 sm:gap-4">
                            <motion.div
                                initial={{ scale: 0, rotate: -180 }}
                                animate={{ scale: 1, rotate: 0 }}
                                transition={{ type: "spring", stiffness: 260, damping: 20, delay: 0.3 }}
                                className="shrink-0 w-12 h-12 sm:w-14 sm:h-14 rounded-2xl bg-gradient-to-br from-blue-500 via-purple-500 to-pink-500 flex items-center justify-center shadow-2xl shadow-purple-500/50"
                            >
                                <HiRocketLaunch className="text-2xl sm:text-3xl text-white" />
                            </motion.div>
                            <div>
                                <h1 className={`!text-xl sm:!text-xl lg:!text-xl font-black mb-0 ${
                                    isDarkMode ? 'text-white' : 'text-gray-900'
                                }`}>
                                    Choose Your Plan
                                </h1>
                                <p className={`text-xs sm:text-sm ${
                                    isDarkMode ? 'text-gray-400' : 'text-gray-600'
                                }`}>
                                    Select the perfect plan for your needs
                                </p>
                            </div>
                        </div>
                    </motion.div>

                    {/* Tabs - full width on mobile */}
                    <div className="flex gap-2 w-full sm:w-auto sm:flex-1 px-2">
                        {tabConfig.map((tab, index) => (
                            <button
                                key={tab.value}
                                onClick={() => setSelectedTab(tab.value)}
                                className={`
                                    group relative
                                    flex-1 sm:flex-auto px-4 sm:px-6 py-2
                                    transition-all duration-300
                                    ${selectedTab === tab.value 
                                        ? 'bg-white dark:bg-gray-700 shadow-xl scale-105'
                                        : 'hover:bg-white/50 dark:hover:bg-gray-700/50 hover:scale-102'
                                    }
                                    rounded-xl
                                    border ${selectedTab === tab.value 
                                        ? isDarkMode 
                                            ? 'border-white/20' 
                                            : 'border-gray-200'
                                        : 'border-transparent'
                                    }
                                `}
                            >
                                {/* Attention glow effect for non-selected tabs */}
                                {tab.attention && selectedTab !== tab.value && (
                                    <>
                                        <motion.div
                                            animate={{
                                                opacity: [0.3, 0.6, 0.3],
                                                scale: [1, 1.05, 1],
                                            }}
                                            transition={{
                                                duration: 2,
                                                repeat: Infinity,
                                                ease: "easeInOut"
                                            }}
                                            className={`absolute inset-0 bg-gradient-to-br ${tab.gradient} opacity-20 rounded-xl blur-sm`}
                                        />
                                        <motion.div
                                            animate={{
                                                boxShadow: [
                                                    '0 0 20px rgba(236, 72, 153, 0.4)',
                                                    '0 0 30px rgba(236, 72, 153, 0.6)',
                                                    '0 0 20px rgba(236, 72, 153, 0.4)',
                                                ]
                                            }}
                                            transition={{
                                                duration: 2,
                                                repeat: Infinity,
                                                ease: "easeInOut"
                                            }}
                                            className="absolute inset-0 rounded-xl"
                                        />
                                    </>
                                )}
                                
                                {/* Gradient background for active tab */}
                                {selectedTab === tab.value && (
                                    <motion.div
                                        layoutId="activeTabSubscription"
                                        className={`absolute inset-0 bg-gradient-to-br ${tab.gradient} opacity-5`}
                                        transition={{
                                            type: "spring",
                                            stiffness: 380,
                                            damping: 30
                                        }}
                                    />
                                )}
                                
                                {/* Hover gradient effect */}
                                <div 
                                    className={`absolute inset-0 bg-gradient-to-br ${tab.gradient} opacity-0 group-hover:opacity-5 transition-opacity duration-300`}
                                />
                                
                                {/* Tab content */}
                                <div className="relative z-10 flex items-center justify-center gap-2">
                                    {/* Icon wrapper with gradient */}
                                    <motion.div
                                        whileHover={{ scale: 1.15, rotate: selectedTab === tab.value ? 0 : 5 }}
                                        whileTap={{ scale: 0.95 }}
                                        className={`
                                            flex items-center justify-center
                                            ${selectedTab === tab.value
                                                ? `p-1.5 rounded-lg bg-gradient-to-br ${tab.gradient} shadow-lg`
                                                : tab.attention
                                                    ? 'lg:text-transparent bg-clip-text bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500'
                                                    : 'text-gray-600 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white'
                                            }
                                            transition-all duration-300
                                        `}
                                    >
                                        {selectedTab === tab.value ? (
                                            <div className="text-white">
                                                {tab.icon}
                                            </div>
                                        ) : (
                                            tab.icon
                                        )}
                                    </motion.div>
                                    
                                    {/* Label with animated gradient for attention tabs */}
                                    {tab.attention && selectedTab !== tab.value ? (
                                        <div className="flex lg:flex items-center gap-1 lg:gap-2">
                                            <motion.span
                                                animate={{
                                                    backgroundPosition: ['0% 50%', '100% 50%', '0% 50%'],
                                                }}
                                                transition={{
                                                    duration: 3,
                                                    repeat: Infinity,
                                                    ease: "linear"
                                                }}
                                                className="font-bold shrink-0 text-xs lg:text-sm whitespace-nowrap bg-gradient-to-r from-purple-600 via-pink-600 to-orange-600 bg-clip-text text-transparent"
                                                style={{
                                                    backgroundSize: '200% auto',
                                                }}
                                            >
                                                {tab.label}
                                            </motion.span>
                                            
                                            {/* NEW badge next to label (or standalone on very small screens) */}
                                            <motion.div
                                                animate={{
                                                    scale: [1, 1.15, 1],
                                                }}
                                                transition={{
                                                    duration: 1.5,
                                                    repeat: Infinity,
                                                    ease: "easeInOut"
                                                }}
                                                className="bg-gradient-to-r hidden sm:block from-pink-500 to-orange-500 text-white text-[9px] font-bold px-1.5 py-0.5 rounded-full shadow-lg"
                                            >
                                                NEW
                                            </motion.div>
                                        </div>
                                    ) : (
                                        <span className={`
                                            hidden sm:inline font-semibold text-sm whitespace-nowrap
                                            ${selectedTab === tab.value
                                                ? 'text-gray-900 dark:text-white'
                                                : 'text-gray-600 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white'
                                            }
                                            transition-colors duration-300
                                        `}>
                                            {tab.label}
                                        </span>
                                    )}
                                </div>
                            </button>
                        ))}
                    </div>
                </div>
            </motion.div>

            {/* Scrollable Content Area */}
            <div className="flex-1 md:overflow-y-auto lg:overflow-y-auto pb-8 lg:pb-0">
                <AnimatePresence mode="wait">
                    <motion.div
                        key={selectedTab}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -20 }}
                        transition={{ duration: 0.4, ease: [0.4, 0, 0.2, 1] }}
                        className='flex flex-col lg:flex-row w-full gap-4 p-4 !pl-0 !pr-0 lg:p-6 lg:!pl-6 lg:!pr-6 bg-secondary-600 dark:bg-gray-900'
                    >
                <div className='w-full flex flex-col lg:flex-row whitespace-nowrap lg:whitespace-normal overflow-x-hidden lg:overflow-auto gap-4 pl-4 pr-4 lg:pl-0 lg:pr-0'>
                    {/* <div className='block lg:hidden w-full'>
                        <Carousel
                            showThumbs={false}
                            showStatus={false}
                            selectedItem={Math.max(plans?.filter(e => !(HIDDEN_PLANS_WHEN_NO_SUBSCRIPTION)?.toLowerCase()?.includes(e?.name?.toLowerCase()))?.findIndex(item => item.id === selectedPlan), 0)}
                            onChange={(index) => setSelectedPlan(plans?.filter(e => !(HIDDEN_PLANS_WHEN_NO_SUBSCRIPTION)?.toLowerCase()?.includes(e?.name?.toLowerCase()))?.[index]?.id)}
                            className="product-carousel"
                        >
                            {plans && plans
                                .filter(e => !(HIDDEN_PLANS_WHEN_NO_SUBSCRIPTION)?.toLowerCase()?.includes(e?.name?.toLowerCase()))
                                .filter(e => selectedTab == "social" ? SOCIAL_PLANS.includes(e?.name) : AI_STUDIO_PLANS.includes(e?.name))
                                .map((item, key) => (
                                        <motion.div
                                            key={key}
                                            initial={{ opacity: 0, scale: 0.95 }}
                                            animate={{ opacity: 1, scale: 1 }}
                                            transition={{ delay: key * 0.1, duration: 0.3 }}
                                            className="px-2"
                                        >
                                        <ProductPlan
                                            key={key}
                                            index={key}
                                            setSelectedPlan={setSelectedPlan}
                                            item={item}
                                            selectedPlan={selectedPlan}
                                            billingFrequency={billingFrequency}
                                        />
                                        </motion.div>
                                ))}
                        </Carousel>
                    </div> */}
                    <div className='flex flex-col lg:gap-4 w-full'>
                        {plans && plans
                            .filter(e => !(HIDDEN_PLANS_WHEN_NO_SUBSCRIPTION)?.toLowerCase()?.includes(e?.name?.toLowerCase()))
                            .filter(e => selectedTab == "social" ? SOCIAL_PLANS.includes(e?.name) : AI_STUDIO_PLANS.includes(e?.name))
                            .map((item, key) => (
                                <motion.div
                                    key={key}
                                    initial={{ opacity: 0, x: -20 }}
                                    animate={{ opacity: 1, x: 0 }}
                                    transition={{ delay: key * 0.1, duration: 0.4 }}
                                >
                                    <ProductPlan
                                        key={key}
                                        index={key}
                                        setSelectedPlan={setSelectedPlan}
                                        item={item}
                                        selectedPlan={selectedPlan}
                                        billingFrequency={billingFrequency}
                                    />
                                </motion.div>
                            ))}
                    </div>
                </div>
                <div className='shrink-0 px-4 lg:px-0'>
                    <Card bodyClass="flex flex-col !px-0 gap-3 py-6 pb-6 rounded-3xl h-auto bg-secondary-500 dark:bg-gray-800 border-tertiary-100">
                        <div className='flex flex-col gap-4 px-6'>
                            <h6 className='font-bold text-tertiary-700 !text-sm'><Trans i18nKey={`subscription.billingFrequency`}>Billing Frequency</Trans></h6>
                            <Radio.Group vertical value={billingFrequency} onChange={(val) => setBillingFrequency(val)}>
                                <Radio className="flex items-center justify-between gap-20 !text-xs" value={'month'}><span className='text-tertiary-500 dark:text-gray-400'><Trans i18nKey={`subscription.monthly`}>Monthly</Trans></span></Radio>
                                <Radio className="flex items-center justify-between gap-20 !text-xs" value={'year'}>
                                    <div className='flex items-center gap-2 w-full'>
                                        <span className='text-tertiary-500 dark:text-gray-400'><Trans i18nKey={`subscription.annualy`}>Annualy</Trans></span> 
                                        <Button variant="solid" className='font-bold rounded-lg !p-1 !px-2.5 inline-block !h-auto !text-xs flex gap-1.5 items-center bg-primary w-auto'>
                                            <HiRocketLaunch />
                                            <span><Trans i18nKey={`subscription.save`}>Save</Trans> 35%</span>
                                        </Button>
                                    </div>
                                </Radio>
                            </Radio.Group>
                        </div>
                        <hr />
                        <div className='flex flex-col px-6'>
                            <div className='flex items-center justify-between cursor-pointer' onClick={() => setIsCustomizePlanOpened(!isCustomizePlanOpened)}>
                                <h6 className='font-bold text-tertiary-700 !text-sm'><Trans i18nKey={`subscription.customizeYourPlan`}>Customize Your Plan</Trans></h6>
                                <TbChevronDown 
                                    className={`text-primary-600 text-lg cursor-pointer transition-all duration-300 ${isCustomizePlanOpened ? 'rotate-180' : ''}`}
                                />
                            </div>
                            <div className={`${isCustomizePlanOpened ? 'max-h-[1000px] py-4 pb-2 opacity-100' : 'max-h-0 opacity-0'} flex flex-col gap-4 transition-all duration-300`}>
                                <div>
                                    <label className='px-2 mb-1 !text-xs flex w-full items-center justify-between'>
                                        <span className='text-tertiary-500 dark:text-gray-400'><Trans i18nKey={`subscription.additionalCompanies`}>Additional Companies</Trans></span>
                                        <span className='text-primary-500'>+${formatNumber(parseInt(products?.filter(e => e.name.includes('add-company'))[0]?.prices?.filter(e => e.recurring == billingFrequency)[0]?.amount) / (billingFrequency == 'year' ? 12 : 1) / 100)} / month</span>
                                    </label>
                                    <div className='w-full relative select-none'>
                                        <InputModern value={additionalCompanies} className="text-center pointer-events-none select-none !bg-gray-100 dark:!bg-gray-700 text-tertiary-500 dark:text-gray-50" />
                                        <HiMinus onClick={removeCompanies} className='text-lg absolute text-primary-600 left-3 top-1/2 -translate-y-1/2 cursor-pointer' />
                                        <HiPlus onClick={addCompanies} className='text-lg absolute text-primary-600 right-3 top-1/2 -translate-y-1/2 cursor-pointer' />
                                    </div>
                                </div>
                                <div>
                                    <label className='px-2 mb-1 !text-xs flex w-full items-center justify-between'>
                                        <span className='text-tertiary-500 dark:text-gray-400'><Trans i18nKey={`subscription.additionalUsers`}>Additional Users</Trans></span>
                                        <span className='text-primary-500'>+${formatNumber(parseInt(products?.filter(e => e.name.includes('add-user'))[0]?.prices?.filter(e => e.recurring == billingFrequency)[0]?.amount) / (billingFrequency == 'year' ? 12 : 1) / 100)} / month</span>
                                    </label>
                                    <div className='w-full relative select-none'>
                                        <InputModern value={additionalUsers} className="text-center pointer-events-none select-none !bg-gray-100 dark:!bg-gray-700 text-tertiary-500 dark:text-gray-50" />
                                        <HiMinus onClick={removeUsers} className='text-lg absolute text-primary-600 left-3 top-1/2 -translate-y-1/2 cursor-pointer' />
                                        <HiPlus onClick={addUsers} className='text-lg absolute text-primary-600 right-3 top-1/2 -translate-y-1/2 cursor-pointer' />
                                    </div>
                                </div>
                                <div>
                                    <label className='px-2 mb-1 !text-xs flex w-full items-center justify-between'>
                                        <span className='text-tertiary-500 dark:text-gray-400'><Trans i18nKey={`subscription.additionalWords`}>Additional AI Text Credits</Trans></span>
                                    </label>
                                    <Select 
                                        value={selectedAdditionalWords > 0 
                                            ? { value: selectedAdditionalWords, label: `${formatNumber(products.filter(e => e.id == selectedAdditionalWords)[0]?.words_amount)} ($${formatNumber(getPrice(products.filter(e => e.id == selectedAdditionalWords)[0])?.amount / (billingFrequency == 'year' ? 12 : 1) / 100)} / month)` }
                                            : { value: "0", label: "No additional words" }
                                        } 
                                        className="!min-h-auto"
                                        fieldsetClassName="bg-gray-100 dark:bg-gray-700 !border-0 text-tertiary-500 dark:text-gray-50 !rounded-lg"
                                        controlStyles={{
                                            minHeight: 'auto',
                                            padding: '3px 5px !important',
                                            color: 'text-tertiary-500 dark:text-gray-400'
                                        }}
                                        style={{
                                            menu: (provided) => ({ ...provided, zIndex: 9999 })
                                        }}
                                        dropdownProps={{
                                            className: "text-sm text-primary-600 !bg-secondary-400"

                                        }}
                                        placeholder=""
                                        onChange={(option) => setSelectedAdditionalWords(option.value)}
                                        options={[
                                            { value: "0", label: "No additional words" },
                                            ...products.filter(e => e.name.includes("words") && getPrice(e)).map((item) => {
                                                return {
                                                    value: item?.id,
                                                    label: `${formatNumber(item?.words_amount)} ($${formatNumber(getPrice(item)?.amount / (billingFrequency == 'year' ? 12 : 1) / 100)} / month)`
                                                }
                                            })
                                        ]}
                                    />
                                </div>
                                <div>
                                    <label className='px-2 mb-1 !text-xs flex w-full items-center justify-between'>
                                        <span className='text-tertiary-500 dark:text-gray-400'><Trans i18nKey={`subscription.additionalImages`}>Additional AI Media Credits</Trans></span>
                                    </label>
                                    <Select 
                                        value={selectedAdditionalImages > 0 
                                            ? { value: selectedAdditionalImages, label: `${formatNumber(products.filter(e => e.id == selectedAdditionalImages)[0]?.images_amount)} ($${formatNumber(getPrice(products.filter(e => e.id == selectedAdditionalImages)[0])?.amount / (billingFrequency == 'year' ? 12 : 1) / 100)} / month)` }
                                            : { value: "0", label: "No additional images" }
                                        } 
                                        fieldsetClassName="bg-gray-100 dark:bg-gray-700 !border-0 text-tertiary-500 dark:text-gray-50 !rounded-lg"
                                        controlStyles={{
                                            minHeight: 'auto',
                                            padding: '3px 5px !important',
                                            color: 'text-tertiary-500 dark:text-gray-400'
                                        }}
                                        style={{
                                            menu: (provided) => ({ ...provided, zIndex: 9999 })
                                        }}
                                        dropdownProps={{
                                            className: "text-sm text-primary-600 bg-secondary-400"
                                        }}
                                        placeholder=""
                                        onChange={(option) => setSelectedAdditionalImages(option.value)}
                                        options={[
                                            { value: "0", label: "No additional images" },
                                            ...products.filter(e => e.name.includes("images") && getPrice(e)).map((item) => {
                                                return {
                                                    value: item?.id,
                                                    label: `${formatNumber(item?.images_amount)} ($${formatNumber(getPrice(item)?.amount / (billingFrequency == 'year' ? 12 : 1) / 100)} / month)`
                                                }
                                            })
                                        ]}
                                    />
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div className='px-6 flex flex-col gap-2'>
                            <div className='flex items-center justify-between'>
                                <span className='text-tertiary-600 dark:text-gray-50 text-sm'><Trans i18nKey={`subscription.monthlyTotal`}>Monthly total</Trans></span>
                                <h3 className='mega-title text-tertiary-600 !font-bold text-2xl'>${formatNumber(total / (billingFrequency == "year" ? 12 : 1), 0)}</h3>
                            </div>
                            {billingFrequency == "year" && 
                                <div className='flex items-center justify-between'>
                                    <small className='text-tertiary-500 dark:text-gray-400'><Trans i18nKey={`subscription.billedYearly`}>Billed yearly</Trans></small>
                                    <small className='text-tertiary-500 dark:text-gray-400'>${formatNumber(total, 0)}</small>
                                </div>
                            }
                        </div>
                        <hr className='hidden lg:block' />
                        <div className='px-6 hidden lg:block'>
                            <Button onClick={() => handleOnNext()} disabled={!selectedPlan || !products || total == 0 || isSubmittingChangePlan} loading={isSubmittingChangePlan} variant="solid" size="md" className="flex justify-center gap-4 items-center !px-4 w-full !text-sm">
                                {!!user?.subscription
                                    ? <span><Trans i18nKey={`subscription.changePlan`}>Change Plan</Trans></span>
                                    : HAS_PAID_TRIAL
                                        ? <span><Trans i18nKey={`subscription.startPaidTrial`}>Start {{ days: FREE_TRIAL_DAYS }}-Day Trial for {{ price: TRIAL_PRICE_DISPLAY }}</Trans></span>
                                        : HAS_FREE_TRIAL
                                            ? <span><Trans i18nKey={`subscription.startFreeTrial`}>Start {{ days: FREE_TRIAL_DAYS }}-Day Free Trial</Trans></span>
                                            : <span><Trans i18nKey={`subscription.subscribe`}>Subscribe</Trans></span>
                                }
                                <HiChevronRight />
                            </Button>
                            {!user?.subscription && <>
                                {!!FREE_TRIAL_DAYS ? <>
                                    <small className='text-center mt-2 w-full block !text-xs text-tertiary-500 dark:text-gray-400'>
                                        <Trans i18nKey={`subscription.youWontBeChargedUntil`}>You won't be charged until</Trans>{" "}
                                        {new Date(freeTrialdEndsAt).toLocaleDateString()}.
                                    </small>
                                </> : <>
                                    <small className='w-full block text-center !text-xs opacity-60 mt-2'><Trans i18nKey={`subscription.refundPolicy`}>15-day money back guarantee.<br/>You can cancel at any time.</Trans></small>
                                </>}
                            </>}
                            <div className='text-red-600 mt-4 flex items-center gap-1 justify-center cursor-pointer' onClick={() => {
                                actions.logout();
                            }}>
                                <TbPower />
                                <span><Trans i18nKey={`userDropdown.logOut`}>Log out</Trans></span>
                            </div>
                        </div>
                    </Card>
                </div>
                    </motion.div>
                </AnimatePresence>
            </div>

            {/* Fixed Footer CTA - Mobile Only */}
            <motion.div
                initial={{ y: 100, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.5, duration: 0.4 }}
                className="lg:hidden fixed bottom-0 left-0 right-0 z-30 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 shadow-2xl"
            >
                <div className="px-4 py-4 pb-2">
                    <div className="flex items-center justify-between mb-3">
                        <div>
                            <span className="text-xs text-tertiary-500 dark:text-gray-400">
                                <Trans i18nKey={`subscription.monthlyTotal`}>Monthly total</Trans>
                            </span>
                            <div className="flex items-baseline gap-2">
                                <h3 className="text-2xl font-bold text-tertiary-600 dark:text-white">
                                    ${formatNumber(total / (billingFrequency == "year" ? 12 : 1), 0)}
                                </h3>
                                <span className="text-xs text-tertiary-500 dark:text-gray-400">/mo</span>
                            </div>
                            {billingFrequency == "year" && (
                                <small className="text-xs text-tertiary-500 dark:text-gray-400">
                                    ${formatNumber(total, 0)} <Trans i18nKey={`subscription.billedYearly`}>billed yearly</Trans>
                                </small>
                            )}
                        </div>
                        <Button 
                            onClick={() => handleOnNext()} 
                            disabled={!selectedPlan || !products || total == 0 || isSubmittingChangePlan} 
                            loading={isSubmittingChangePlan} 
                            variant="solid" 
                            size="md" 
                            className="flex justify-center gap-2 items-center !px-6 !py-3 !text-sm font-semibold whitespace-nowrap"
                        >
                            {!!user?.subscription
                                ? <span><Trans i18nKey={`subscription.changePlan`}>Change Plan</Trans></span>
                                : HAS_PAID_TRIAL
                                    ? <span><Trans i18nKey={`subscription.startPaidTrial`}>Start {{ days: FREE_TRIAL_DAYS }}-Day Trial for {{ price: TRIAL_PRICE_DISPLAY }}</Trans></span>
                                    : HAS_FREE_TRIAL
                                        ? <span>Start Trial</span>
                                        : <span><Trans i18nKey={`subscription.subscribe`}>Subscribe</Trans></span>
                            }
                            <HiChevronRight className="text-lg" />
                        </Button>
                    </div>
                    {!user?.subscription && !!FREE_TRIAL_DAYS && (
                        <small className="text-center w-full block text-[10px] text-tertiary-500 dark:text-gray-400">
                            <Trans i18nKey={`subscription.youWontBeChargedUntil`}>You won't be charged until</Trans>{" "}
                            {new Date(freeTrialdEndsAt).toLocaleDateString()}
                        </small>
                    )}
                </div>
            </motion.div>
            
            <CardDialog 
                cardDialogOpened={cardDialogOpened} 
                setCardDialogOpened={setCardDialogOpened} 
                handleSubmitStripe={handleSubmitStripe} 
                isSubmittingCard={isSubmittingCard}
                subscriptionCreated={subscriptionCreated}
                handleStripeCheckout={() => handleSubmitStripe(undefined, true)}
            />
        </div>
    );
}

export default Subscription;
